"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogsProcessor = void 0;
var LogParser_1 = require("./LogParser");
var LogDocumentBuilder_1 = require("./LogDocumentBuilder");
var LogsProcessor = /** @class */ (function () {
    function LogsProcessor(collectionNameBuilder) {
        this.collectionNameBuilder = collectionNameBuilder;
    }
    LogsProcessor.prototype.process = function (batch) {
        var updates = [];
        if (batch.abi.length < 1) {
            return updates;
        }
        var logParser = new LogParser_1.LogParser(batch.abi);
        for (var _i = 0, _a = batch.logs; _i < _a.length; _i++) {
            var log = _a[_i];
            var logParams = logParser.read(log);
            var document = LogDocumentBuilder_1.LogDocumentBuilder.build(log, logParams, batch.block, batch.confirmed, batch.chainId);
            updates.push({
                collectionName: this.collectionNameBuilder.build(batch.tag),
                document: document,
            });
        }
        return updates;
    };
    return LogsProcessor;
}());
exports.LogsProcessor = LogsProcessor;
//# sourceMappingURL=LogsProcessor.js.map